module.exports = __webpack_public_path__ + "img/2.b59d6330.png";